// import React, { useState, useEffect } from "react";
// import { MdVisibility, MdVisibilityOff } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import { useContext } from "react";
// import { LoginContext } from "../../../lib/loginContext";
// import sicunetImage from "../../../assets/images/sicunet_bg.jpg";
// import mainLogo from "../../../assets/images/mainLogo.png";
// import { validateLoginInput, sanitizeInput } from "../../../lib/securityUtils";

// const Login = () => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [usernameFocused, setUsernameFocused] = useState(false);
//   const [passwordFocused, setPasswordFocused] = useState(false);
//   const navigate = useNavigate();
//   const { login, isLoggedIn } = useContext(LoginContext);

//   // Redirect if already logged in
//   useEffect(() => {
//     if (isLoggedIn) {
//       const redirectPath = localStorage.getItem("redirectAfterLogin") || "/";
//       localStorage.removeItem("redirectAfterLogin");
//       navigate(redirectPath, { replace: true });
//     }
//   }, [isLoggedIn, navigate]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccessMessage("");

//     // Validate input
//     const validation = validateLoginInput(username, password);
//     if (!validation.isValid) {
//       setError(Object.values(validation.errors).join(", "));
//       return;
//     }

//     setIsLoading(true);

//     // Sanitize inputs
//     const sanitizedUsername = sanitizeInput(username.trim());

//     fetch("https://sicunet.com/api/login/", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "X-Requested-With": "XMLHttpRequest",
//       },
//       body: JSON.stringify({
//         userId: sanitizedUsername,
//         password: password,
//       }),
//     })
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         return response.json();
//       })
//       .then((data) => {
//         setIsLoading(false);
//         if (data.success) {
//           // Show success message
//           setSuccessMessage(" Success");

//           // Store token if available
//           if (data.data.access_token) {
//             localStorage.setItem("authToken", data.data.access_token);
//           }
//           // Pass userName if available, otherwise use userId
//           const userName = data.data.user_name || data.data.user_id;
//           const userId = data.data.user_id;
//           const roleName = data.data.role_name; // Get role_name from response

//           // Redirect to saved path or home after a brief delay
//           setTimeout(() => {
//             login(userId, roleName, userName); // Pass roleName to login
//             const redirectPath =
//               localStorage.getItem("redirectAfterLogin") || "/";
//             localStorage.removeItem("redirectAfterLogin");
//             navigate(redirectPath, { replace: true });
//           }, 500);
//         } else {
//           // Handle login failure (e.g., show error message)
//           setError(data.message || "Login failed");
//           console.error("Login failed:", data.message);
//         }
//       })
//       .catch((error) => {
//         setIsLoading(false);
//         setError("An error occurred. Please try again.");
//         console.error("Error during login:", error);
//       });
//   };

//   return (
//     <div className="flex h-screen relative">
//       {/* Left Side - Login Form */}
//       <div className="flex w-full lg:w-1/2 py-10 lg:py-[345px] px-4 lg:px-[180px] flex-col justify-center items-center gap-[10px] bg-[#0041C0] lg:bg-white">
//         <div className="w-full max-w-md bg-white lg:bg-transparent rounded-lg shadow-lg p-6 lg:p-0 lg:rounded-none lg:shadow-none">
//           <div className="flex flex-col items-center gap-4 self-stretch mb-8">
//             <div className="text-center">
//               <h1 className="text-[48px] font-semibold text-black leading-normal mb-2">
//                 Login
//               </h1>
//               <p className="text-[16px] font-normal text-black leading-normal text-center font-['Poppins']">
//                 Sign in with your Username and Password
//               </p>
//             </div>
//           </div>

//           {error && (
//             <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
//               <p className="text-sm text-red-800">{error}</p>
//             </div>
//           )}

//           <form
//             onSubmit={handleSubmit}
//             className="flex flex-col items-center gap-4 self-stretch"
//           >
//             <div className="flex flex-col items-center gap-4 self-stretch w-full">
//               <div className="w-full">
//                 <div className="relative flex h-[52px] px-4 justify-between items-center self-stretch border border-gray-300 rounded-lg overflow-hidden">
//                   <div className="flex items-center pointer-events-none z-10">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="20"
//                       height="20"
//                       viewBox="0 0 20 20"
//                       fill="none"
//                     >
//                       <path
//                         d="M10.0001 8.33335C11.841 8.33335 13.3334 6.84097 13.3334 5.00002C13.3334 3.15907 11.841 1.66669 10.0001 1.66669C8.15913 1.66669 6.66675 3.15907 6.66675 5.00002C6.66675 6.84097 8.15913 8.33335 10.0001 8.33335Z"
//                         fill="#016FFC"
//                       />
//                       <path
//                         opacity="0.5"
//                         d="M16.6666 14.5833C16.6666 16.6541 16.6666 18.3333 9.99992 18.3333C3.33325 18.3333 3.33325 16.6541 3.33325 14.5833C3.33325 12.5125 6.31825 10.8333 9.99992 10.8333C13.6816 10.8333 16.6666 12.5125 16.6666 14.5833Z"
//                         fill="#016FFC"
//                       />
//                     </svg>
//                   </div>
//                   <input
//                     type="text"
//                     placeholder="Enter Username"
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                     onFocus={() => setUsernameFocused(true)}
//                     onBlur={() => setUsernameFocused(false)}
//                     required
//                     className="flex-1 h-full px-3 text-sm bg-white text-gray-900 border-0 focus:outline-none focus:ring-0 placeholder-gray-400 autofill-fix"
//                   />
//                 </div>
//               </div>

//               <div className="w-full">
//                 <div className="relative flex h-[52px] px-4 justify-between items-center self-stretch border border-gray-300 rounded-lg overflow-hidden">
//                   <div className="flex items-center pointer-events-none z-10">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="20"
//                       height="20"
//                       viewBox="0 0 20 20"
//                       fill="none"
//                     >
//                       <path
//                         opacity="0.5"
//                         d="M1.66675 13.3333C1.66675 10.9766 1.66675 9.79748 2.39925 9.06581C3.13091 8.33331 4.31008 8.33331 6.66675 8.33331H13.3334C15.6901 8.33331 16.8692 8.33331 17.6009 9.06581C18.3334 9.79748 18.3334 10.9766 18.3334 13.3333C18.3334 15.69 18.3334 16.8691 17.6009 17.6008C16.8692 18.3333 15.6901 18.3333 13.3334 18.3333H6.66675C4.31008 18.3333 3.13091 18.3333 2.39925 17.6008C1.66675 16.8691 1.66675 15.69 1.66675 13.3333Z"
//                         fill="#016FFC"
//                       />
//                       <path
//                         d="M6.66667 14.1667C6.88768 14.1667 7.09964 14.0789 7.25592 13.9226C7.4122 13.7663 7.5 13.5544 7.5 13.3334C7.5 13.1123 7.4122 12.9004 7.25592 12.7441C7.09964 12.5878 6.88768 12.5 6.66667 12.5C6.44565 12.5 6.23369 12.5878 6.07741 12.7441C5.92113 12.9004 5.83333 13.1123 5.83333 13.3334C5.83333 13.5544 5.92113 13.7663 6.07741 13.9226C6.23369 14.0789 6.44565 14.1667 6.66667 14.1667ZM10 14.1667C10.221 14.1667 10.433 14.0789 10.5893 13.9226C10.7455 13.7663 10.8333 13.5544 10.8333 13.3334C10.8333 13.1123 10.7455 12.9004 10.5893 12.7441C10.433 12.5878 10.221 12.5 10 12.5C9.77899 12.5 9.56702 12.5878 9.41074 12.7441C9.25446 12.9004 9.16667 13.1123 9.16667 13.3334C9.16667 13.5544 9.25446 13.7663 9.41074 13.9226C9.56702 14.0789 9.77899 14.1667 10 14.1667ZM14.1667 13.3334C14.1667 13.5544 14.0789 13.7663 13.9226 13.9226C13.7663 14.0789 13.5543 14.1667 13.3333 14.1667C13.1123 14.1667 12.9004 14.0789 12.7441 13.9226C12.5878 13.7663 12.5 13.5544 12.5 13.3334C12.5 13.1123 12.5878 12.9004 12.7441 12.7441C12.9004 12.5878 13.1123 12.5 13.3333 12.5C13.5543 12.5 13.7663 12.5878 13.9226 12.7441C14.0789 12.9004 14.1667 13.1123 14.1667 13.3334ZM5.625 6.66669C5.625 5.50636 6.08594 4.39357 6.90641 3.57309C7.72688 2.75262 8.83968 2.29169 10 2.29169C11.1603 2.29169 12.2731 2.75262 13.0936 3.57309C13.9141 4.39357 14.375 5.50636 14.375 6.66669V8.33669C14.8475 8.34085 15.2617 8.35169 15.625 8.37835V6.66669C15.625 5.17484 15.0324 3.7441 13.9775 2.68921C12.9226 1.63432 11.4918 1.04169 10 1.04169C8.50816 1.04169 7.07742 1.63432 6.02252 2.68921C4.96763 3.7441 4.375 5.17484 4.375 6.66669V8.37919C4.79112 8.35199 5.20799 8.33782 5.625 8.33669V6.66669Z"
//                         fill="#016FFC"
//                       />
//                     </svg>
//                   </div>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     placeholder="Enter Password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     onFocus={() => setPasswordFocused(true)}
//                     onBlur={() => setPasswordFocused(false)}
//                     required
//                     className="flex-1 h-full px-3 text-sm bg-white text-gray-900 border-0 focus:outline-none focus:ring-0 placeholder-gray-400 autofill-fix"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     className="flex items-center text-gray-400 hover:text-gray-600 focus:outline-none z-10"
//                   >
//                     {showPassword ? (
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="16"
//                         height="16"
//                         viewBox="0 0 16 16"
//                         fill="none"
//                       >
//                         <path
//                           d="M15.47 7.83C14.8989 6.33541 13.903 5.04056 12.605 4.105L15 1.705L14.295 1L1.00003 14.295L1.70503 15L4.25503 12.455C5.39342 13.118 6.68286 13.4778 8.00003 13.5C9.62977 13.4387 11.2058 12.9012 12.5334 11.954C13.861 11.0067 14.882 9.69118 15.47 8.17C15.5097 8.06015 15.5097 7.93985 15.47 7.83ZM8.00003 11.25C7.31083 11.2497 6.6398 11.0289 6.08503 10.62L7.00003 9.715C7.37943 9.92288 7.816 10.0021 8.24426 9.94087C8.67252 9.87961 9.06936 9.68114 9.37527 9.37524C9.68117 9.06933 9.87964 8.67248 9.9409 8.24423C10.0022 7.81597 9.92291 7.3794 9.71503 7L10.62 6.095C10.9723 6.5788 11.1839 7.15058 11.2314 7.74713C11.279 8.34368 11.1606 8.94176 10.8895 9.47526C10.6184 10.0088 10.205 10.4569 9.69503 10.7701C9.18509 11.0833 8.59847 11.2494 8.00003 11.25ZM2.26503 10.905L4.76503 8.405C4.75221 8.2704 4.7472 8.13518 4.75003 8C4.75135 7.13845 5.09419 6.31257 5.70339 5.70336C6.3126 5.09416 7.13848 4.75132 8.00003 4.75C8.13206 4.75088 8.26394 4.75922 8.39503 4.775L10.285 2.89C9.54943 2.63744 8.77776 2.50573 8.00003 2.5C6.37029 2.56129 4.79423 3.09878 3.46663 4.04604C2.13904 4.99331 1.11811 6.30882 0.530031 7.83C0.490315 7.93985 0.490315 8.06015 0.530031 8.17C0.91456 9.19106 1.50515 10.122 2.26503 10.905Z"
//                           fill="#8A8B91"
//                         />
//                       </svg>
//                     ) : (
//                       <MdVisibility className="w-4 h-4" />
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="w-full">
//               <button
//                 type="submit"
//                 disabled={isLoading}
//                 className="group flex h-[52px] py-4 px-8 justify-center items-center gap-2 self-stretch w-full bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 font-medium text-sm disabled:opacity-60 disabled:cursor-not-allowed"
//               >
//                 {isLoading ? (
//                   <>
//                     <div className="loader-modern mr-3 font-bold text-[15px]"></div>
//                     <span>Logging in...</span>
//                   </>
//                 ) : (
//                   <>
//                     <span className="font-bold text-[16px]">Login</span>
//                     <svg
//                       className="w-4 h-4"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={3} // <-- increased from 2 to 3
//                         d="M14 5l7 7m0 0l-7 7m7-7H3"
//                       />
//                     </svg>
//                   </>
//                 )}
//               </button>
//             </div>

//             <div className="flex items-center justify-center">
//               <svg
//                 className="w-4 h-4 text-gray-400 mr-2"
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//               <p className="text-[14px] font-normal text-black/60 text-center leading-normal font-['Poppins']">
//                 User must have an account in the cloud
//               </p>
//             </div>
//           </form>

//           <style jsx>{`
//             .autofill-fix:-webkit-autofill,
//             .autofill-fix:-webkit-autofill:hover,
//             .autofill-fix:-webkit-autofill:focus,
//             .autofill-fix:-webkit-autofill:active {
//               -webkit-box-shadow: 0 0 0 1000px white inset !important;
//               -webkit-text-fill-color: #111827 !important;
//               transition: background-color 5000s ease-in-out 0s;
//             }
//           `}</style>
//         </div>
//       </div>

//       {/* Mobile/Tablet View - Card on Blue Background */}

//       {/* Right Side - Background with Logo (Desktop only) */}
//       <div className="relative lg:w-1/2 p-8 bg-gradient-to-b from-blue-900 to-black flex-col justify-center items-center text-white hidden lg:flex">
//         <div className="absolute inset-0 flex justify-center items-center">
//           <div className="bg-white p-4  shadow-all-side w-full h-full">
//             <img
//               src={sicunetImage}
//               alt="Sicunet Access Control"
//               className="w-full h-full rounded-[12px] object-cover object-center"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Success Message - Bottom of Page */}
//       {successMessage && (
//         <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-[9999] animate-slideInFromBottom">
//           <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-xl shadow-2xl flex items-center space-x-3 border border-green-400/30">
//             <div className="flex-shrink-0">
//               <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
//                 <path
//                   fillRule="evenodd"
//                   d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//             </div>
//             <p className="font-bold text-base">{successMessage}</p>
//           </div>
//         </div>
//       )}

//       <style>{`
//         .loader-modern {
//           width: 20px;
//           height: 20px;
//           border: 3px solid rgba(255, 255, 255, 0.3);
//           border-radius: 50%;
//           border-top-color: #fff;
//           animation: spin 0.7s linear infinite;
//         }

//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }

//         @keyframes shake {
//           0%, 100% { transform: translateX(0); }
//           10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
//           20%, 40%, 60%, 80% { transform: translateX(5px); }
//         }

//         .animate-shake {
//           animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
//         }

//         @keyframes slideInFromBottom {
//           from {
//             opacity: 0;
//             transform: translate(-50%, 20px);
//           }
//           to {
//             opacity: 1;
//             transform: translate(-50%, 0);
//           }
//         }

//         .animate-slideInFromBottom {
//           animation: slideInFromBottom 0.5s ease-out forwards;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Login;
// import React, { useState, useEffect } from "react";
// import { MdVisibility, MdVisibilityOff } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import { useContext } from "react";
// import { LoginContext } from "../../../lib/loginContext";
// import { getSEOData } from "../../utils/constants/seoConfig";
// import SEO from "../SEO/SEO";
// import sicunetImage from "../../../assets/images/sicunet_bg.jpg";
// import mainLogo from "../../../assets/images/mainLogo.png";
// import { validateLoginInput, sanitizeInput } from "../../../lib/securityUtils";

// const Login = () => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [usernameFocused, setUsernameFocused] = useState(false);
//   const [passwordFocused, setPasswordFocused] = useState(false);
//   const navigate = useNavigate();
//   const { login, isLoggedIn } = useContext(LoginContext);

//   // Get SEO data
//   const seoData = getSEOData("/login");

//   // Redirect if already logged in
//   useEffect(() => {
//     if (isLoggedIn) {
//       const redirectPath = localStorage.getItem("redirectAfterLogin") || "/";
//       localStorage.removeItem("redirectAfterLogin");
//       navigate(redirectPath, { replace: true });
//     }
//   }, [isLoggedIn, navigate]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccessMessage("");

//     // Validate input
//     const validation = validateLoginInput(username, password);
//     if (!validation.isValid) {
//       setError(Object.values(validation.errors).join(", "));
//       return;
//     }

//     setIsLoading(true);

//     // Sanitize inputs
//     const sanitizedUsername = sanitizeInput(username.trim());

//     fetch("https://sicunet.com/api/login/", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "X-Requested-With": "XMLHttpRequest",
//       },
//       body: JSON.stringify({
//         userId: sanitizedUsername,
//         password: password,
//       }),
//     })
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         return response.json();
//       })
//       .then((data) => {
//         setIsLoading(false);
//         if (data.success) {
//           // Show success message
//           setSuccessMessage(" Success");

//           // Store token if available
//           if (data.data.access_token) {
//             localStorage.setItem("authToken", data.data.access_token);
//           }
//           // Pass userName if available, otherwise use userId
//           const userName = data.data.user_name || data.data.user_id;
//           const userId = data.data.user_id;
//           const roleName = data.data.role_name; // Get role_name from response

//           // Redirect to saved path or home after a brief delay
//           setTimeout(() => {
//             login(userId, roleName, userName); // Pass roleName to login
//             const redirectPath =
//               localStorage.getItem("redirectAfterLogin") || "/";
//             localStorage.removeItem("redirectAfterLogin");
//             navigate(redirectPath, { replace: true });
//           }, 500);
//         } else {
//           // Handle login failure (e.g., show error message)
//           setError(data.message || "Login failed");
//           console.error("Login failed:", data.message);
//         }
//       })
//       .catch((error) => {
//         setIsLoading(false);
//         setError("An error occurred. Please try again.");
//         console.error("Error during login:", error);
//       });
//   };

//   return (
//     <>
//       <SEO
//         title={seoData.title}
//         description={seoData.description}
//         keywords={seoData.keywords}
//         type="website"
//       />
//       <div className="flex h-screen relative">
//         {/* Left Side - Login Form */}
//         <div className="flex w-full lg:w-1/2 py-10 lg:py-[345px] px-4 lg:px-[180px] flex-col justify-center items-center gap-[10px] bg-[#0041C0] lg:bg-white">
//           <div className="w-full max-w-md bg-white lg:bg-transparent rounded-lg shadow-lg p-6 lg:p-0 lg:rounded-none lg:shadow-none">
//             <div className="flex flex-col items-center gap-4 self-stretch mb-8">
//               <div className="text-center">
//                 <h1 className="text-[48px] font-semibold text-black leading-normal mb-2">
//                   Login
//                 </h1>
//                 <p className="text-[16px] font-normal text-black leading-normal text-center font-['Poppins']">
//                   Sign in with your Username and Password
//                 </p>
//               </div>
//             </div>

//             {error && (
//               <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
//                 <p className="text-sm text-red-800">{error}</p>
//               </div>
//             )}

//             <form
//               onSubmit={handleSubmit}
//               className="flex flex-col items-center gap-4 self-stretch"
//             >
//               <div className="flex flex-col items-center gap-4 self-stretch w-full">
//                 <div className="w-full">
//                   <div className="relative flex h-[52px] px-4 justify-between items-center self-stretch border border-gray-300 rounded-lg overflow-hidden">
//                     <div className="flex items-center pointer-events-none z-10">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="20"
//                         height="20"
//                         viewBox="0 0 20 20"
//                         fill="none"
//                       >
//                         <path
//                           d="M10.0001 8.33335C11.841 8.33335 13.3334 6.84097 13.3334 5.00002C13.3334 3.15907 11.841 1.66669 10.0001 1.66669C8.15913 1.66669 6.66675 3.15907 6.66675 5.00002C6.66675 6.84097 8.15913 8.33335 10.0001 8.33335Z"
//                           fill="#016FFC"
//                         />
//                         <path
//                           opacity="0.5"
//                           d="M16.6666 14.5833C16.6666 16.6541 16.6666 18.3333 9.99992 18.3333C3.33325 18.3333 3.33325 16.6541 3.33325 14.5833C3.33325 12.5125 6.31825 10.8333 9.99992 10.8333C13.6816 10.8333 16.6666 12.5125 16.6666 14.5833Z"
//                           fill="#016FFC"
//                         />
//                       </svg>
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="Enter Username"
//                       value={username}
//                       onChange={(e) => setUsername(e.target.value)}
//                       onFocus={() => setUsernameFocused(true)}
//                       onBlur={() => setUsernameFocused(false)}
//                       required
//                       className="flex-1 h-full px-3 text-sm bg-white text-gray-900 border-0 focus:outline-none focus:ring-0 placeholder-gray-400 autofill-fix"
//                     />
//                   </div>
//                 </div>

//                 <div className="w-full">
//                   <div className="relative flex h-[52px] px-4 justify-between items-center self-stretch border border-gray-300 rounded-lg overflow-hidden">
//                     <div className="flex items-center pointer-events-none z-10">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="20"
//                         height="20"
//                         viewBox="0 0 20 20"
//                         fill="none"
//                       >
//                         <path
//                           opacity="0.5"
//                           d="M1.66675 13.3333C1.66675 10.9766 1.66675 9.79748 2.39925 9.06581C3.13091 8.33331 4.31008 8.33331 6.66675 8.33331H13.3334C15.6901 8.33331 16.8692 8.33331 17.6009 9.06581C18.3334 9.79748 18.3334 10.9766 18.3334 13.3333C18.3334 15.69 18.3334 16.8691 17.6009 17.6008C16.8692 18.3333 15.6901 18.3333 13.3334 18.3333H6.66675C4.31008 18.3333 3.13091 18.3333 2.39925 17.6008C1.66675 16.8691 1.66675 15.69 1.66675 13.3333Z"
//                           fill="#016FFC"
//                         />
//                         <path
//                           d="M6.66667 14.1667C6.88768 14.1667 7.09964 14.0789 7.25592 13.9226C7.4122 13.7663 7.5 13.5544 7.5 13.3334C7.5 13.1123 7.4122 12.9004 7.25592 12.7441C7.09964 12.5878 6.88768 12.5 6.66667 12.5C6.44565 12.5 6.23369 12.5878 6.07741 12.7441C5.92113 12.9004 5.83333 13.1123 5.83333 13.3334C5.83333 13.5544 5.92113 13.7663 6.07741 13.9226C6.23369 14.0789 6.44565 14.1667 6.66667 14.1667ZM10 14.1667C10.221 14.1667 10.433 14.0789 10.5893 13.9226C10.7455 13.7663 10.8333 13.5544 10.8333 13.3334C10.8333 13.1123 10.7455 12.9004 10.5893 12.7441C10.433 12.5878 10.221 12.5 10 12.5C9.77899 12.5 9.56702 12.5878 9.41074 12.7441C9.25446 12.9004 9.16667 13.1123 9.16667 13.3334C9.16667 13.5544 9.25446 13.7663 9.41074 13.9226C9.56702 14.0789 9.77899 14.1667 10 14.1667ZM14.1667 13.3334C14.1667 13.5544 14.0789 13.7663 13.9226 13.9226C13.7663 14.0789 13.5543 14.1667 13.3333 14.1667C13.1123 14.1667 12.9004 14.0789 12.7441 13.9226C12.5878 13.7663 12.5 13.5544 12.5 13.3334C12.5 13.1123 12.5878 12.9004 12.7441 12.7441C12.9004 12.5878 13.1123 12.5 13.3333 12.5C13.5543 12.5 13.7663 12.5878 13.9226 12.7441C14.0789 12.9004 14.1667 13.1123 14.1667 13.3334ZM5.625 6.66669C5.625 5.50636 6.08594 4.39357 6.90641 3.57309C7.72688 2.75262 8.83968 2.29169 10 2.29169C11.1603 2.29169 12.2731 2.75262 13.0936 3.57309C13.9141 4.39357 14.375 5.50636 14.375 6.66669V8.33669C14.8475 8.34085 15.2617 8.35169 15.625 8.37835V6.66669C15.625 5.17484 15.0324 3.7441 13.9775 2.68921C12.9226 1.63432 11.4918 1.04169 10 1.04169C8.50816 1.04169 7.07742 1.63432 6.02252 2.68921C4.96763 3.7441 4.375 5.17484 4.375 6.66669V8.37919C4.79112 8.35199 5.20799 8.33782 5.625 8.33669V6.66669Z"
//                           fill="#016FFC"
//                         />
//                       </svg>
//                     </div>
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       placeholder="Enter Password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       onFocus={() => setPasswordFocused(true)}
//                       onBlur={() => setPasswordFocused(false)}
//                       required
//                       className="flex-1 h-full px-3 text-sm bg-white text-gray-900 border-0 focus:outline-none focus:ring-0 placeholder-gray-400 autofill-fix"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowPassword(!showPassword)}
//                       className="flex items-center text-gray-400 hover:text-gray-600 focus:outline-none z-10"
//                     >
//                       {showPassword ? (
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="16"
//                           height="16"
//                           viewBox="0 0 16 16"
//                           fill="none"
//                         >
//                           <path
//                             d="M15.47 7.83C14.8989 6.33541 13.903 5.04056 12.605 4.105L15 1.705L14.295 1L1.00003 14.295L1.70503 15L4.25503 12.455C5.39342 13.118 6.68286 13.4778 8.00003 13.5C9.62977 13.4387 11.2058 12.9012 12.5334 11.954C13.861 11.0067 14.882 9.69118 15.47 8.17C15.5097 8.06015 15.5097 7.93985 15.47 7.83ZM8.00003 11.25C7.31083 11.2497 6.6398 11.0289 6.08503 10.62L7.00003 9.715C7.37943 9.92288 7.816 10.0021 8.24426 9.94087C8.67252 9.87961 9.06936 9.68114 9.37527 9.37524C9.68117 9.06933 9.87964 8.67248 9.9409 8.24423C10.0022 7.81597 9.92291 7.3794 9.71503 7L10.62 6.095C10.9723 6.5788 11.1839 7.15058 11.2314 7.74713C11.279 8.34368 11.1606 8.94176 10.8895 9.47526C10.6184 10.0088 10.205 10.4569 9.69503 10.7701C9.18509 11.0833 8.59847 11.2494 8.00003 11.25ZM2.26503 10.905L4.76503 8.405C4.75221 8.2704 4.7472 8.13518 4.75003 8C4.75135 7.13845 5.09419 6.31257 5.70339 5.70336C6.3126 5.09416 7.13848 4.75132 8.00003 4.75C8.13206 4.75088 8.26394 4.75922 8.39503 4.775L10.285 2.89C9.54943 2.63744 8.77776 2.50573 8.00003 2.5C6.37029 2.56129 4.79423 3.09878 3.46663 4.04604C2.13904 4.99331 1.11811 6.30882 0.530031 7.83C0.490315 7.93985 0.490315 8.06015 0.530031 8.17C0.91456 9.19106 1.50515 10.122 2.26503 10.905Z"
//                             fill="#8A8B91"
//                           />
//                         </svg>
//                       ) : (
//                         <MdVisibility className="w-4 h-4" />
//                       )}
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               <div className="w-full">
//                 <button
//                   type="submit"
//                   disabled={isLoading}
//                   className="group flex h-[52px] py-4 px-8 justify-center items-center gap-2 self-stretch w-full bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 font-medium text-sm disabled:opacity-60 disabled:cursor-not-allowed"
//                 >
//                   {isLoading ? (
//                     <>
//                       <div className="loader-modern mr-3 font-bold text-[15px]"></div>
//                       <span>Logging in...</span>
//                     </>
//                   ) : (
//                     <>
//                       <span className="font-bold text-[16px]">Login</span>
//                       <svg
//                         className="w-4 h-4"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={3}
//                           d="M14 5l7 7m0 0l-7 7m7-7H3"
//                         />
//                       </svg>
//                     </>
//                   )}
//                 </button>
//               </div>

//               <div className="flex items-center justify-center">
//                 <svg
//                   className="w-4 h-4 text-gray-400 mr-2"
//                   fill="currentColor"
//                   viewBox="0 0 20 20"
//                 >
//                   <path
//                     fillRule="evenodd"
//                     d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
//                     clipRule="evenodd"
//                   />
//                 </svg>
//                 <p className="text-[14px] font-normal text-black/60 text-center leading-normal font-['Poppins']">
//                   User must have an account in the cloud
//                 </p>
//               </div>
//             </form>

//             <style jsx>{`
//               .autofill-fix:-webkit-autofill,
//               .autofill-fix:-webkit-autofill:hover,
//               .autofill-fix:-webkit-autofill:focus,
//               .autofill-fix:-webkit-autofill:active {
//                 -webkit-box-shadow: 0 0 0 1000px white inset !important;
//                 -webkit-text-fill-color: #111827 !important;
//                 transition: background-color 5000s ease-in-out 0s;
//               }
//             `}</style>
//           </div>
//         </div>

//         {/* Right Side - Background with Logo (Desktop only) */}
//         <div className="relative lg:w-1/2 p-8 bg-gradient-to-b from-blue-900 to-black flex-col justify-center items-center text-white hidden lg:flex">
//           <div className="absolute inset-0 flex justify-center items-center">
//             <div className="bg-white p-4  shadow-all-side w-full h-full">
//               <img
//                 src={sicunetImage}
//                 alt="Sicunet Access Control"
//                 className="w-full h-full rounded-[12px] object-cover object-center"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Success Message - Bottom of Page */}
//         {successMessage && (
//           <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-[9999] animate-slideInFromBottom">
//             <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-xl shadow-2xl flex items-center space-x-3 border border-green-400/30">
//               <div className="flex-shrink-0">
//                 <svg
//                   className="w-6 h-6"
//                   fill="currentColor"
//                   viewBox="0 0 20 20"
//                 >
//                   <path
//                     fillRule="evenodd"
//                     d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
//                     clipRule="evenodd"
//                   />
//                 </svg>
//               </div>
//               <p className="font-bold text-base">{successMessage}</p>
//             </div>
//           </div>
//         )}

//         <style>{`
//           .loader-modern {
//             width: 20px;
//             height: 20px;
//             border: 3px solid rgba(255, 255, 255, 0.3);
//             border-radius: 50%;
//             border-top-color: #fff;
//             animation: spin 0.7s linear infinite;
//           }
          
//           @keyframes spin {
//             to { transform: rotate(360deg); }
//           }
          
//           @keyframes shake {
//             0%, 100% { transform: translateX(0); }
//             10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
//             20%, 40%, 60%, 80% { transform: translateX(5px); }
//           }
          
//           .animate-shake {
//             animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
//           }
          
//           @keyframes slideInFromBottom {
//             from {
//               opacity: 0;
//               transform: translate(-50%, 20px);
//             }
//             to {
//               opacity: 1;
//               transform: translate(-50%, 0);
//             }
//           }

//           .animate-slideInFromBottom {
//             animation: slideInFromBottom 0.5s ease-out forwards;
//           }
//         `}</style>
//       </div>
//     </>
//   );
// };

// export default Login;
import React, { useState, useEffect } from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LoginContext } from "../../../lib/loginContext";
import { getSEOData } from "../../utils/constants/seoConfig";
import SEO from "../SEO/SEO";
import sicunetImage from "../../../assets/images/sicunet_bg.jpg";
import mainLogo from "../../../assets/images/mainLogo.png";
import { validateLoginInput, sanitizeInput } from "../../../lib/securityUtils";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [usernameFocused, setUsernameFocused] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const navigate = useNavigate();
  const { login, isLoggedIn } = useContext(LoginContext);

  // Get SEO data
  const seoData = getSEOData("/login");

  // Redirect if already logged in
  useEffect(() => {
    if (isLoggedIn) {
      const redirectPath = localStorage.getItem("redirectAfterLogin") || "/";
      localStorage.removeItem("redirectAfterLogin");
      navigate(redirectPath, { replace: true });
    }
  }, [isLoggedIn, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");

    // Validate input
    const validation = validateLoginInput(username, password);
    if (!validation.isValid) {
      setError(Object.values(validation.errors).join(", "));
      return;
    }

    setIsLoading(true);

    // Sanitize inputs
    const sanitizedUsername = sanitizeInput(username.trim());

    fetch("https://sicunet.com/api/login/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        userId: sanitizedUsername,
        password: password,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setIsLoading(false);
        if (data.success) {
          // Show success message
          setSuccessMessage(" Success");

          // Store token if available
          if (data.data.access_token) {
            localStorage.setItem("authToken", data.data.access_token);
          }
          // Pass userName if available, otherwise use userId
          const userName = data.data.user_name || data.data.user_id;
          const userId = data.data.user_id;
          const roleName = data.data.role_name; // Get role_name from response

          // Redirect to saved path or home after a brief delay
          setTimeout(() => {
            login(userId, roleName, userName); // Pass roleName to login
            const redirectPath =
              localStorage.getItem("redirectAfterLogin") || "/";
            localStorage.removeItem("redirectAfterLogin");
            navigate(redirectPath, { replace: true });
          }, 500);
        } else {
          // Handle login failure (e.g., show error message)
          setError(data.message || "Login failed");
          console.error("Login failed:", data.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setError("An error occurred. Please try again.");
        console.error("Error during login:", error);
      });
  };

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <div className="flex h-screen relative">
        {/* Left Side - Login Form */}
        <div className="flex w-full lg:w-1/2 py-10 lg:py-[345px] px-4 lg:px-[180px] flex-col justify-center items-center gap-[10px] bg-[#0041C0] lg:bg-white">
          <div className="w-full max-w-md bg-white lg:bg-transparent rounded-lg shadow-lg p-6 lg:p-0 lg:rounded-none lg:shadow-none">
            <div className="flex flex-col items-center gap-4 self-stretch mb-8">
              <div className="text-center">
                <h1 className="text-[48px] font-semibold text-black leading-normal mb-2">
                  Login
                </h1>
                <p className="text-[16px] font-normal text-black leading-normal text-center font-['Poppins']">
                  Sign in with your Username and Password
                </p>
              </div>
            </div>

            {error && (
              <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-sm text-red-800">{error}</p>
              </div>
            )}

            <form
              onSubmit={handleSubmit}
              className="flex flex-col items-center gap-4 self-stretch"
            >
              <div className="flex flex-col items-center gap-4 self-stretch w-full">
                {/* Username Input */}
                <div className="w-full group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2 ml-1">
                    Username
                  </label>
                  <div className={`relative flex h-[56px] px-5 justify-between items-center self-stretch border-2 rounded-xl overflow-hidden transition-all duration-300 shadow-sm hover:shadow-md bg-white ${
                    usernameFocused 
                      ? 'border-[#0041C0] shadow-lg shadow-blue-100 ring-4 ring-blue-50' 
                      : 'border-gray-200 hover:border-gray-300'
                  }`}>
                    <div className={`flex items-center pointer-events-none z-10 transition-transform duration-300 ${usernameFocused ? 'scale-110' : ''}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M10.0001 8.33335C11.841 8.33335 13.3334 6.84097 13.3334 5.00002C13.3334 3.15907 11.841 1.66669 10.0001 1.66669C8.15913 1.66669 6.66675 3.15907 6.66675 5.00002C6.66675 6.84097 8.15913 8.33335 10.0001 8.33335Z"
                          fill={usernameFocused ? "#0041C0" : "#016FFC"}
                          className="transition-colors duration-300"
                        />
                        <path
                          opacity="0.5"
                          d="M16.6666 14.5833C16.6666 16.6541 16.6666 18.3333 9.99992 18.3333C3.33325 18.3333 3.33325 16.6541 3.33325 14.5833C3.33325 12.5125 6.31825 10.8333 9.99992 10.8333C13.6816 10.8333 16.6666 12.5125 16.6666 14.5833Z"
                          fill={usernameFocused ? "#0041C0" : "#016FFC"}
                          className="transition-colors duration-300"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      placeholder="Enter your username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      onFocus={() => setUsernameFocused(true)}
                      onBlur={() => setUsernameFocused(false)}
                      required
                      className="flex-1 h-full px-4 text-[15px] font-medium bg-transparent text-gray-900 border-0 focus:outline-none focus:ring-0 placeholder-gray-400 autofill-fix"
                    />
                  </div>
                </div>

                {/* Password Input */}
                <div className="w-full group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2 ml-1">
                    Password
                  </label>
                  <div className={`relative flex h-[56px] px-5 justify-between items-center self-stretch border-2 rounded-xl overflow-hidden transition-all duration-300 shadow-sm hover:shadow-md bg-white ${
                    passwordFocused 
                      ? 'border-[#0041C0] shadow-lg shadow-blue-100 ring-4 ring-blue-50' 
                      : 'border-gray-200 hover:border-gray-300'
                  }`}>
                    <div className={`flex items-center pointer-events-none z-10 transition-transform duration-300 ${passwordFocused ? 'scale-110' : ''}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          opacity="0.5"
                          d="M1.66675 13.3333C1.66675 10.9766 1.66675 9.79748 2.39925 9.06581C3.13091 8.33331 4.31008 8.33331 6.66675 8.33331H13.3334C15.6901 8.33331 16.8692 8.33331 17.6009 9.06581C18.3334 9.79748 18.3334 10.9766 18.3334 13.3333C18.3334 15.69 18.3334 16.8691 17.6009 17.6008C16.8692 18.3333 15.6901 18.3333 13.3334 18.3333H6.66675C4.31008 18.3333 3.13091 18.3333 2.39925 17.6008C1.66675 16.8691 1.66675 15.69 1.66675 13.3333Z"
                          fill={passwordFocused ? "#0041C0" : "#016FFC"}
                          className="transition-colors duration-300"
                        />
                        <path
                          d="M6.66667 14.1667C6.88768 14.1667 7.09964 14.0789 7.25592 13.9226C7.4122 13.7663 7.5 13.5544 7.5 13.3334C7.5 13.1123 7.4122 12.9004 7.25592 12.7441C7.09964 12.5878 6.88768 12.5 6.66667 12.5C6.44565 12.5 6.23369 12.5878 6.07741 12.7441C5.92113 12.9004 5.83333 13.1123 5.83333 13.3334C5.83333 13.5544 5.92113 13.7663 6.07741 13.9226C6.23369 14.0789 6.44565 14.1667 6.66667 14.1667ZM10 14.1667C10.221 14.1667 10.433 14.0789 10.5893 13.9226C10.7455 13.7663 10.8333 13.5544 10.8333 13.3334C10.8333 13.1123 10.7455 12.9004 10.5893 12.7441C10.433 12.5878 10.221 12.5 10 12.5C9.77899 12.5 9.56702 12.5878 9.41074 12.7441C9.25446 12.9004 9.16667 13.1123 9.16667 13.3334C9.16667 13.5544 9.25446 13.7663 9.41074 13.9226C9.56702 14.0789 9.77899 14.1667 10 14.1667ZM14.1667 13.3334C14.1667 13.5544 14.0789 13.7663 13.9226 13.9226C13.7663 14.0789 13.5543 14.1667 13.3333 14.1667C13.1123 14.1667 12.9004 14.0789 12.7441 13.9226C12.5878 13.7663 12.5 13.5544 12.5 13.3334C12.5 13.1123 12.5878 12.9004 12.7441 12.7441C12.9004 12.5878 13.1123 12.5 13.3333 12.5C13.5543 12.5 13.7663 12.5878 13.9226 12.7441C14.0789 12.9004 14.1667 13.1123 14.1667 13.3334ZM5.625 6.66669C5.625 5.50636 6.08594 4.39357 6.90641 3.57309C7.72688 2.75262 8.83968 2.29169 10 2.29169C11.1603 2.29169 12.2731 2.75262 13.0936 3.57309C13.9141 4.39357 14.375 5.50636 14.375 6.66669V8.33669C14.8475 8.34085 15.2617 8.35169 15.625 8.37835V6.66669C15.625 5.17484 15.0324 3.7441 13.9775 2.68921C12.9226 1.63432 11.4918 1.04169 10 1.04169C8.50816 1.04169 7.07742 1.63432 6.02252 2.68921C4.96763 3.7441 4.375 5.17484 4.375 6.66669V8.37919C4.79112 8.35199 5.20799 8.33782 5.625 8.33669V6.66669Z"
                          fill={passwordFocused ? "#0041C0" : "#016FFC"}
                          className="transition-colors duration-300"
                        />
                      </svg>
                    </div>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onFocus={() => setPasswordFocused(true)}
                      onBlur={() => setPasswordFocused(false)}
                      required
                      className="flex-1 h-full px-4 text-[15px] font-medium bg-transparent text-gray-900 border-0 focus:outline-none focus:ring-0 placeholder-gray-400 autofill-fix"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="flex items-center text-gray-400 hover:text-[#0041C0] focus:outline-none z-10 transition-all duration-300 hover:scale-110"
                    >
                      {showPassword ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M15.47 7.83C14.8989 6.33541 13.903 5.04056 12.605 4.105L15 1.705L14.295 1L1.00003 14.295L1.70503 15L4.25503 12.455C5.39342 13.118 6.68286 13.4778 8.00003 13.5C9.62977 13.4387 11.2058 12.9012 12.5334 11.954C13.861 11.0067 14.882 9.69118 15.47 8.17C15.5097 8.06015 15.5097 7.93985 15.47 7.83ZM8.00003 11.25C7.31083 11.2497 6.6398 11.0289 6.08503 10.62L7.00003 9.715C7.37943 9.92288 7.816 10.0021 8.24426 9.94087C8.67252 9.87961 9.06936 9.68114 9.37527 9.37524C9.68117 9.06933 9.87964 8.67248 9.9409 8.24423C10.0022 7.81597 9.92291 7.3794 9.71503 7L10.62 6.095C10.9723 6.5788 11.1839 7.15058 11.2314 7.74713C11.279 8.34368 11.1606 8.94176 10.8895 9.47526C10.6184 10.0088 10.205 10.4569 9.69503 10.7701C9.18509 11.0833 8.59847 11.2494 8.00003 11.25ZM2.26503 10.905L4.76503 8.405C4.75221 8.2704 4.7472 8.13518 4.75003 8C4.75135 7.13845 5.09419 6.31257 5.70339 5.70336C6.3126 5.09416 7.13848 4.75132 8.00003 4.75C8.13206 4.75088 8.26394 4.75922 8.39503 4.775L10.285 2.89C9.54943 2.63744 8.77776 2.50573 8.00003 2.5C6.37029 2.56129 4.79423 3.09878 3.46663 4.04604C2.13904 4.99331 1.11811 6.30882 0.530031 7.83C0.490315 7.93985 0.490315 8.06015 0.530031 8.17C0.91456 9.19106 1.50515 10.122 2.26503 10.905Z"
                            fill="currentColor"
                          />
                        </svg>
                      ) : (
                        <MdVisibility className="w-5 h-5" />
                      )}
                    </button>
                  </div>
                </div>
              </div>

              {/* Login Button */}
              <div className="w-full">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="group relative flex h-[58px] py-4 px-8 justify-center items-center gap-3 self-stretch w-full bg-gradient-to-r from-[#0041C0] via-[#0052E0] to-[#0062FF] text-white rounded-xl hover:shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 font-semibold text-[17px] disabled:opacity-60 disabled:cursor-not-allowed transform hover:scale-[1.02] active:scale-[0.98] overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                  {isLoading ? (
                    <>
                      <div className="loader-modern mr-3"></div>
                      <span className="font-bold text-[16px] tracking-wide">Logging in...</span>
                    </>
                  ) : (
                    <>
                      <span className="font-bold text-[17px] tracking-wide relative z-10">Sign In</span>
                      <svg
                        className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300 relative z-10"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2.5}
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                    </>
                  )}
                </button>
              </div>

              {/* Info Text */}
              <div className="flex items-center justify-center bg-blue-50 rounded-lg px-4 py-3 border border-blue-100">
                <svg
                  className="w-5 h-5 text-[#0041C0] mr-2 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  />
                </svg>
                <p className="text-[13px] font-medium text-gray-700 text-center leading-relaxed font-['Poppins']">
                  User must have an account in the cloud
                </p>
              </div>
            </form>

            <style jsx>{`
              .autofill-fix:-webkit-autofill,
              .autofill-fix:-webkit-autofill:hover,
              .autofill-fix:-webkit-autofill:focus,
              .autofill-fix:-webkit-autofill:active {
                -webkit-box-shadow: 0 0 0 1000px white inset !important;
                -webkit-text-fill-color: #111827 !important;
                transition: background-color 5000s ease-in-out 0s;
              }
            `}</style>
          </div>
        </div>

        {/* Right Side - Background with Logo (Desktop only) */}
        <div className="relative lg:w-1/2 p-8 bg-gradient-to-b from-blue-900 to-black flex-col justify-center items-center text-white hidden lg:flex">
          <div className="absolute inset-0 flex justify-center items-center">
            <div className="bg-white p-4 shadow-all-side w-full h-full">
              <img
                src={sicunetImage}
                alt="Sicunet Access Control"
                className="w-full h-full rounded-[12px] object-cover object-center"
              />
            </div>
          </div>
        </div>

        {/* Success Message - Bottom of Page */}
        {successMessage && (
          <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-[9999] animate-slideInFromBottom">
            <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-xl shadow-2xl flex items-center space-x-3 border border-green-400/30">
              <div className="flex-shrink-0">
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <p className="font-bold text-base">{successMessage}</p>
            </div>
          </div>
        )}

        <style>{`
          .loader-modern {
            width: 22px;
            height: 22px;
            border: 3px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            border-top-color: #fff;
            animation: spin 0.8s linear infinite;
          }
          
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          
          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
            20%, 40%, 60%, 80% { transform: translateX(5px); }
          }
          
          .animate-shake {
            animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
          }
          
          @keyframes slideInFromBottom {
            from {
              opacity: 0;
              transform: translate(-50%, 20px);
            }
            to {
              opacity: 1;
              transform: translate(-50%, 0);
            }
          }

          .animate-slideInFromBottom {
            animation: slideInFromBottom 0.5s ease-out forwards;
          }
        `}</style>
      </div>
    </>
  );
};

export default Login;